<!-- <i class="fas fa-file-search"></i> 
 {{"label_log" | translate:param }} -->
<div class="d-flex flex-column justify-content-center align-items-center ">
    <img src="../../../assets/svg-icons/file-search.svg" alt="" width="20px" class="margin-top-2 filter-amber">
    {{"label_log" | translate:param }}
</div>